module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vrassets/_next/static/images/ImageNotFound-be8d5506aafc7ff3767e0bd0056c575e.svg";